import { motion } from "framer-motion";
import { CalendarDays, Clock3 } from "lucide-react";
import { scrollToSignup } from "../../lib/scroll";
import { Reveal } from "./Reveal";

export default function FinalCta() {
    return (
        <section className="py-14 sm:py-20 px-4 sm:px-8" data-testid="final-cta-section">
            <Reveal>
                <div className="max-w-5xl mx-auto text-center rounded-[2.5rem] bg-brand-tint border border-brand-tint2 px-6 sm:px-12 py-14 sm:py-20 relative overflow-hidden">
                    <div
                        aria-hidden="true"
                        className="absolute -top-20 left-1/2 -translate-x-1/2 w-[30rem] h-[30rem] rounded-full bg-white/70 blur-3xl"
                    />
                    <div className="relative">
                        <h2 className="text-3xl sm:text-5xl font-extrabold tracking-tight text-brand-ink leading-[1.12] max-w-3xl mx-auto">
                            Dołącz do nas i wyjdź z webinaru z gotowym bankiem gier na swoje zajęcia.
                        </h2>
                        <div className="mt-7 flex flex-wrap justify-center gap-3">
                            <span className="inline-flex items-center gap-2 rounded-full bg-white px-4 py-2 text-sm font-semibold text-brand-ink border border-brand-tint2">
                                <CalendarDays className="w-4 h-4 text-brand" aria-hidden="true" />
                                3.11.2026 (wtorek)
                            </span>
                            <span className="inline-flex items-center gap-2 rounded-full bg-white px-4 py-2 text-sm font-semibold text-brand-ink border border-brand-tint2">
                                <Clock3 className="w-4 h-4 text-brand" aria-hidden="true" />
                                godz. 21:00 · online
                            </span>
                        </div>
                        <motion.button
                            type="button"
                            onClick={scrollToSignup}
                            whileHover={{ scale: 1.04 }}
                            whileTap={{ scale: 0.97 }}
                            data-testid="final-cta-button"
                            className="mt-9 inline-flex items-center gap-3 rounded-full bg-brand-deep px-10 py-5 text-lg font-extrabold text-white shadow-[0_20px_45px_-15px_rgba(194,24,91,0.65)] transition-colors duration-200 hover:bg-brand"
                        >
                            Zapisuję się bezpłatnie
                            <span aria-hidden="true">↓</span>
                        </motion.button>
                    </div>
                </div>
            </Reveal>
        </section>
    );
}
